import { FilterInput } from '@kinetic-ui/data-layer';
import { useCallback } from 'react';
import { TransformFactory } from '../transforms';

export const useToForms = ({
  transforms,
}: {
  transforms: Record<string, { transformer: TransformFactory }>;
}) => {
  return useCallback(
    (filterInputs: FilterInput[]) => {
      const newFormValues = filterInputs.reduce((acc, filterInput) => {
        let transformerDictionary = transforms[filterInput.field];
        if (!transformerDictionary) {
          /**
           * for two filters that have the same field value:
           * We append the filter operator from filterInput to the field name.
           * So theres a chance the above lookup fails, so we check for the filter operator key here
           */
          transformerDictionary = transforms[`${filterInput.field}__${filterInput.operator}`];
        }
        const toForm = transformerDictionary?.transformer?.toForm;
        if (!toForm) {
          console.error(
            `No transformer found for field: ${filterInput.field} with operator: ${filterInput.operator}`
          );
          return acc;
        }
        const transformedFilterValues = toForm({ filter: filterInput, formValues: acc });
        return {
          ...acc,
          ...transformedFilterValues,
        };
      }, {});
      return newFormValues;
    },
    [transforms]
  );
};
